module.exports = __webpack_public_path__ + "static/img/rank_21.e59f373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_21.png
// module id = 3rrI
// module chunks = 1